'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAddress = _react2.default.createClass({
    displayName: 'UserAddress',
    render: function render() {
        var columns = [{
            title: '姓名',
            key: 'name',
            dataIndex: 'name'
        }, {
            title: '手机',
            key: 'mobile',
            dataIndex: 'mobile'
        }, {
            title: '所在区域',
            key: 'district',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'span',
                    null,
                    record.province,
                    '\xA0\xA0',
                    record.city,
                    '\xA0\xA0',
                    record.district
                );
            }
        }, {
            title: '住址',
            key: 'street',
            dataIndex: 'street'
        }, {
            title: '地址别称',
            key: 'alias',
            dataIndex: 'alias'
        }];

        var pagination = Object.assign(_constants.PaginationConfig, {
            total: this.props.addresses.length,
            onChange: function onChange(current, pageSize) {

            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            dataSource: this.props.addresses,
            showHeader: true,
            pagination: pagination,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };

        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = UserAddress;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/user_address.js
// module id = 1332
// module chunks = 0